import config from '../config'
import { authHeader } from './auth-header'

export const geoService = {
  getAllCities,
  addNewCity
}

function getAllCities () {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return fetch(`${config.apiUrl}/countries/getAllCities`, requestOptions).then(handleResponse)
}

function addNewCity (cityName) {
  console.log(JSON.stringify({name: cityName, stateId: 1, countryId: 1}))
  const requestOptions = {
    method: 'POST',
    body: JSON.stringify({name: cityName, stateId: 1, countryId: 1}),
    headers: authHeader()
  }
  return fetch(`${config.apiUrl}/countries/addCity`, requestOptions).then(handleResponse)
}

function handleResponse (response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        // logout()
        // location.reload(true)
      }

      const error = (data && data.message) || response.statusText
      return Promise.reject(error)
    }
    return data.Response
  })
}
